// extracted by mini-css-extract-plugin
module.exports = {"buttons-holder":"DraggableFilterButtons_buttons-holder__IrbO5","buttonsHolder":"DraggableFilterButtons_buttons-holder__IrbO5","button":"DraggableFilterButtons_button__eUsnS"};